import { wishListErrorMessages } from 'features/wishList/desktop';

function deleteWishList (wishlistId, successCallback, errorCallback) {

	$.ajax({
		type: 'DELETE',
		url: `/api/globalwishlists/${lp.wishlist.wishlistToken}`,
		success (response) {

			// check if successful
			if (response.Success) {

				successCallback();

			} else {

				// show error message
				errorCallback(wishListErrorMessages[response.ErrorMessage]);

			}

		},
		error () {

			errorCallback('Error deleting wish list.');

		}
	});

}

export default deleteWishList;
